import React from 'react'
import OrderList from './OrderList'

function Started({status}) {
  return (
    <OrderList status={status}/>
  )
}

export default Started